<template>
  <div v-if="load_status === 'done'">
    <transition name="fade-juju-overlay">
      <div class="jujuna__overlay" v-if="routeChanged">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="129.998"
          height="130"
          viewBox="0 0 129.998 130"
        >
          <g
            id="Group_99"
            data-name="Group 99"
            transform="translate(-692.335 -235.632)"
          >
            <path
              id="Path_211"
              data-name="Path 211"
              d="M813.616,268.141a64.988,64.988,0,1,1-88.775-23.793,64.984,64.984,0,0,1,88.775,23.793"
              transform="translate(0 0)"
              fill="#bacb32"
              fill-rule="evenodd"
            />
            <path
              id="Path_212"
              data-name="Path 212"
              d="M745.512,316.678c-5.486,3.168-10.917,1.961-13.483-2.483-2.225-3.855-1.571-8.184.8-9.553a2.058,2.058,0,0,1,2.635.455,6.217,6.217,0,0,0-.263,7.07c1.54,2.667,4.341,3.416,7.155,1.791,5.481-3.165,4.232-8.762.4-16.426-8.8-17.638-19.755-37.982-23.431-44.351-.55,6.238-3.478,11.088-6.429,15.558,5.349-.318,10.362,1.525,12.245,4.785,2.992,5.183.537,10.165-3.912,12.734-3.553,2.052-7.953,1.62-10.005-1.933a4.563,4.563,0,0,1,1.545-6.225c1.556,1.669,3.664,3.615,6.928,1.731a3.071,3.071,0,0,0,1.124-4.209c-1.8-3.109-6.194-3.54-9.881-3.773a2.617,2.617,0,0,1-2.07-1.178c-.429-.742-.323-1.594.525-2.871,8.661-12.7,4.964-18.083,10.3-21.163,4.294-2.478,7.912,4.127,10.367,8.041,3.4,5.543,10.181,17.63,18.984,35.271,4.884,9.827,8.468,19.8-3.53,26.729"
              transform="translate(25.796 16.574)"
              fill="#101820"
            />
          </g>
        </svg>
      </div>
    </transition>
    <transition name="fade">
      <div
        v-if="_.get($store.state.main.selected_menu, 'id') && !routeChanged"
        class="page-wrapper"
      >
        <SignModal />
        <PortalTarget name="modal" multiple></PortalTarget>
        <component
          :is="selectedLayout"
          :key="selectedLayout"
          v-if="selectedLayout"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import mainMixin from "@/mixins/main";
import pageRouting from "@/mixins/pageRouting";
import SignModal from "@/components/layout/SignModal";

export default {
  name: "App",
  mixins: [mainMixin, pageRouting],
  components: { SignModal },
  metaInfo() {
    let titleData =
      _.get(this.$store.state.main.selected_menu, "seo.title") ||
      _.get(this.$store.state.main.selected_menu, "title") ||
      _.get(this.$store.state.main.indx, "siteSettings.website_title");

    if (_.get(this.$store.state.main.selected_menu, "seo.title"))
      titleData = _.get(this.$store.state.main.selected_menu, "seo.title");
    const contentTitle =
      _.get(this.$store.state.main.selected_menu, "seo.title") ||
      _.get(this.$store.state.main.selected_menu, "title");
    const description =
      _.get(this.$store.state.main.selected_menu, "seo.description") ||
      _.get(
        this.$store.state.main.indx,
        "siteSettings.website_meta_description"
      );
    const keyword =
      _.get(this.$store.state.main.selected_menu, "seo.keywords") ||
      _.get(this.$store.state.main.indx, "siteSettings.website_meta_keywords");
    // if no subcomponents specify a metaInfo.title, this title will be used

    return {
      title: contentTitle,
      // all titles will be injected into this template
      titleTemplate: titleData,
      meta: [
        {
          vmid: "description",
          name: "description",
          content: description
        },
        {
          vmid: "keyword",
          name: "keyword",
          content: keyword
        }
      ]
    };
  },

  data() {
    return {
      selectedLayout: "",
      routeChanged: false
    };
  },
  mounted() {
    // console.log(this.load_status);
    //  console.log(this.$route)
    if (window.innerWidth <= 1023) window.scrollTo(0, 1);
    if (this.$route.query && this.$route.query.token) {
      localStorage.userToken = this.$route.query.token;
    }
    setTimeout(() => {
      this.authorizationHandler();
    }, 500);
    this.detectTheme();
    if (this.$route.name && this.$route.name.indexOf("PageViewRouter") >= 0)
      this.$store.commit("main/setState", { key: "showSite", val: true });
  },

  watch: {
    $route: {
      immediate: true,
      deep: true,
      handler: function() {
        this.pageRoutingSelectMenuByPath();
      }
    },

    shroute(ns, os) {
      // console.log("jskhdkjsahdsa")
      this.routeChanged = true;
      setTimeout(() => {
        this.routeChanged = false;
      }, 1600);
    },

    "$store.state.main.selected_menu.id": {
      immediate: true,
      handler() {
        this.setLayoutTemplate();

        // console.log(this.selectedLayout, this.$store.state.main.selected_menu );
      }
    },

    "$store.state.main.indx.smartLayouts": {
      handler() {
        this.importLayouts();
        this.pageRoutingSelectMenuByPath();
        this.setLayoutTemplate();

        // console.log(this.selectedLayout, this.$store.state.main.selected_menu );
      }
    },
    load_status(ns, os) {
      console.log(ns);
    }
  },
  computed: {
    shroute() {
      return this.$route;
    },
    load_status() {
      return this.$store.state.main.current_content_request_status;
    }
  },
  methods: {
    detectTheme() {
      let hr = new Date().getHours();
      if (hr >= 6 && hr < 18) {
        document.body.setAttribute("data-theme", "day");
      } else {
        document.body.setAttribute("data-theme", "night");
      }
    },
    importLayouts() {
      /// dinamicaly import all layouts as components
      let components = _.get(this.$store.state.main.indx, "smartLayouts");

      for (let i in components) {
        this.$options.components[i] = () => import("./views/layouts/" + i);
      }
      return true;
    },

    setLayoutTemplate() {
      if (
        this.$options.components[
          _.get(this.$store.state.main.selected_menu, "currentLayoutTemplate")
        ]
      ) {
        this.selectedLayout = this.$store.state.main.selected_menu.currentLayoutTemplate;
      }
    },

    async authorizationHandler() {
      // console.log(typeof(localStorage.getItem('userToken')))
      // console.log(localStorage['userToken'])
      // if(localStorage['userToken']) console.log('jshdjas')

      if (
        localStorage["userToken"] !== "false" &&
        localStorage["userToken"] &&
        localStorage["userToken"] !== "undefined" &&
        localStorage["userToken"] &&
        localStorage["userToken"] !== "null" &&
        localStorage["userToken"]
      ) {
        let data = await this.$fn.postData("user/getuserdata", {
          token: localStorage.userToken,
          uniqueID: localStorage.uniqueID
        });
        this.$store.commit("main/getUser", data.data);
        //  console.log(data);
        // console.log("exists")
        // console.log(this.$store.state.main.userData)
      } else {
        // console.log("doesnt exist")
      }
    }
  },

  created() {}
};
</script>

<style lang="scss">
.jujuna__overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999999999999999;
  svg {
    animation: 0.7s rotateJujuLogo ease alternate infinite;
  }
}

.fade-juju-overlay-enter-active,
.fade-juju-overlay-leave-active {
  transition-duration: 0.4s;
  transition-property: opacity;
  transition-timing-function: ease;
  opacity: 1;
}

.fade-juju-overlay-enter,
.fade-juju-overlay-leave-active {
  opacity: 0;
}
@keyframes rotateJujuLogo {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
